/**
 * Computes the SHA-256 hash of a string and optionally returns a substring of specified length
 * @param input - The string to hash
 * @param length - Optional length to truncate the hash result (defaults to full hash length)
 * @returns The SHA-256 hash as a hexadecimal string, optionally truncated to specified length
 */ export async function computeSha256Hash(input, length) {
    // Convert string to ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    // Compute SHA-256 hash
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((byte)=>byte.toString(16).padStart(2, "0")).join("");
    // Return full hash or truncated version based on length parameter
    if (length !== undefined && length > 0) {
        return hashHex.substring(0, Math.min(length, hashHex.length));
    }
    return hashHex;
}
